import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SEEDLINGORIGIN_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SeedlingOrigin.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const SEEDLINGORIGIN_CONFIG = {
  entityName: 'SeedlingOrigin',
  localizationKey: 'Planning::Entity.SeedlingOrigin',
  fields: SEEDLINGORIGIN_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.SeedlingOrigins',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
